import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import type { UserScreenNode } from '@/shared/types/system';
import { useTabsStore } from './tabsStore';
import type { OpenTabOptions } from './model/types';

/** Ekranı sekmede açar (varsa odaklar) ve URL'yi /s/:screenId ile senkronlar. */
export function useOpenScreen() {
  const openScreen = useTabsStore((s) => s.openScreen);
  const navigate = useNavigate();
  return useCallback(
    (
      node: Pick<
        UserScreenNode,
        'screenId' | 'caption' | 'objectId' | 'screenTypeName' | 'iconId' | 'iconName'
      >,
      params?: Record<string, unknown>,
      opts?: OpenTabOptions,
    ) => {
      const tab = openScreen(node, params, opts);
      // Arka planda açılan sekme adres çubuğunu değiştirmez: kullanıcı hâlâ öndeki sekmede.
      if (opts?.activate !== false) navigate(`/s/${node.screenId}?tab=${tab.tabId}`, { replace: true });
      return tab;
    },
    [openScreen, navigate],
  );
}
